<template lang="pug">
    v-card.mark-card.portal-drawer-dialog(:height="windowHeight" :max-height="windowHeight" elevation='0').portaldrawerDialog
        //- v-col.pt-5
        //-     v-row.d-flex.align-center.my-auto
        //-         v-img(src="@/assets/images/related-images-icon.svg" max-width="22px" width="22px" )
        //-         span.text-title.pl-2 {{$t("PORTAL.RelatedImages")}}
        //-     //- v-row(v-if="detail.related_image.length>0 && !detail.isSkeleton")
        v-card-title.d-flex.justify-between-space.align-start.px-0.pb-1( :class="isUpsideExtension ? 'pt-3':'pt-1'" style='border-bottom: 1px solid #E8E8E8;')
            v-col.closeBtn()
                v-btn.close-line.btn-none-effect(icon @click='onCloseDialog' tile :ripple="false")
                    v-icon(size='35') mdi-chevron-left
                span.ml-2 {{$t("PORTAL.RelatedImages")}}
            v-col(cols="auto")
                v-btn(icon @click='onCloseDialog')
                    v-icon mdi-close
        div.text-scrollbar.pl-4.pr-3.py-4.mt-0
            v-row(v-if="mobileRelatedImages.length>0")
                v-col.pl-0.pr-2.pt-0.pb-2(v-for="(img,index) in filteredImages(mobileRelatedImages)" :key="index" :cols="index==0?12:6")
                    v-card.related-img-card(elevation='0')
                        img(:src="img.doc_image_url" @click='openWindowDisplayImage(img)' @error="handleImageError" :draggable="!disableCopy" style="width:100%; aspect-ratio:16/9; object-fit:cover; cursor:pointer;")
                        v-card-text.ellipsis.related-img-overlay
                            v-chip.related-img-label.mr-1(label) {{img.context_id}}
                            span.text-white(v-if="img.page_num.length>0") Page {{img.page_num.length>0?img.page_num[0]:0}},
                            span.pl-1.text-white(v-if="img.image_num!=''") image {{img.image_num==''?0:img.image_num}}
            v-row.mt-1()
                v-col.py-0.d-flex
                    v-btn.portal-btn-black.px-0(v-if='mobileRelatedImages.length>3' @click='viewLessRelatedImage()' text elevation='0' color="transparent")
                        v-img(src="@/assets/images/related-img-btn.svg" max-width="20px" width="20px")
                        span.ml-1(v-if="showAllImage") {{$t("PORTAL.ViewMore")}}
                            v-icon.ml-1(size='12' color='#444') fa-chevron-down
                        span.ml-1(v-else) {{$t("PORTAL.ViewLess")}}
                            v-icon.ml-1(size='12') fa-chevron-up

</template>
<script>
    import Vue from 'vue';
    import { mapState } from 'vuex';
    import errorbackImage from '@/assets/images/notfundImagexl.jpg';
    export default Vue.extend({
        props: {
            mobileRelatedImages: {
                type: Array,
                require: true,
            },
            disableCopy: {
                type: Boolean,
                default: false
            }
        },
        components: {
            
        },
        async created(){
        },
        beforeDestroy(){
            window.removeEventListener('resize', this.updateWindowHeight)
        },
        data() {
            return{
                windowHeight: window.innerHeight + 70,
                showAllImage: true,
                errorImg: false,
            }
        },
        methods: {
            onCloseDialog(){
                this.$emit("emitPortalRelatedImages",false)
            },
            filteredImages(data){
                let relatedImage = data;
                return this.showAllImage ? relatedImage.slice(0,3) : relatedImage;
            },
            viewLessRelatedImage(){
                this.showAllImage = !this.showAllImage;
            },
            handleImageError(e){
                e.target.src = errorbackImage;
                this.errorImg = true;
            },
            openWindowDisplayImage(img){
                // 存到 localStorage
                const storageKey = 'doc_image_url_temp';
                console.log(img)
                window.localStorage.setItem(storageKey, img.doc_image_url);
                // 開新視窗，不帶 query
                const routeUrl = this.$router.resolve({ path: '/image_url' });
                window.open(routeUrl.href, '_blank');
            },
            updateWindowHeight() {
                this.windowHeight = window.innerHeight + 70;
            }
        },
        computed: {
            ...mapState([
                'isUpsideExtension',
            ]),
        }
    })
</script>
<style scoped></style>